import { Link, useNavigate } from 'react-router-dom';
import '../../themes/global.css'
import { useFirestoreGetPosts } from '../../hooks/useFirestore';

export default function Home() {

    return (
        <>
            <script src="./js/script.js"></script>
            <main>
                <span className="sidebar"></span>
                <div className="content">
                    <FirestoreComponent/>
                </div>
                <span className="sidebar"></span>
            </main>

            <footer className="footer">
                <p>Made with ☕ by <a href="http://raulcrespo.com/" className="emphasis-link"><strong>Raul Crespo</strong></a></p>
            </footer>
        </>
    )
}

const FirestoreComponent: React.FC = () => {
    const { data, loading, error } = useFirestoreGetPosts('posts');

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error}</p>;

    return (
        <div>
            {data.map(item => (
                <article className="article" key={item.uid}>
                    <div className="title"><Link to={`/id/${item.uid}`}>{item.title}</Link></div>
                    <div className="informations">
                        <div className="date">Published on: {item.date}</div>
                    </div>
                </article>
            ))}
        </div>
    );
};